// src/components/PrivateRoute.js
import React, { useContext, useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';

const PrivateRoute = ({ element: Component }) => {
  const { isAuthenticated, isLoading } = useContext(AuthContext);
  const [showSlowConnectionMessage, setShowSlowConnectionMessage] = useState(false);

  useEffect(() => {
    // Show slow connection message after 3 seconds of loading
    const timer = setTimeout(() => {
      if (isLoading) {
        setShowSlowConnectionMessage(true);
      }
    }, 3000);

    return () => clearTimeout(timer);
  }, [isLoading]);

  if (isLoading) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center p-4">
        <div className="card bg-base-200 shadow-lg max-w-md w-full p-6">
          <div className="flex flex-col items-center gap-4">
            <div className="loading loading-spinner loading-lg text-primary"></div>
            <p className="text-base font-medium">Authentifizierung wird überprüft...</p>
            {showSlowConnectionMessage && (
              <div className="text-sm text-base-content/70 text-center animate-fade-in">
                <p>Das dauert länger als gewöhnlich.</p>
                <p>Unsere Server werden möglicherweise gerade aufgeweckt.</p>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  return isAuthenticated ? <Component /> : <Navigate to="/login" />;
};

export default PrivateRoute;